import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitbibleHeaderIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 640 640",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "ahci-clip",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 96,
				height: 96,
				fill: "white"
			})
		}) }),
		/* @__PURE__ */ _jsx("rect", {
			fill: "var(--bs-body-bg)",
			width: 424.42386,
			height: 156.47433,
			x: 95.111855,
			y: 420.33304
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(0,1.680165)",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				strokeWidth: 1.20517,
				d: "M 512.82711,626.8432 H 165.73832 c -63.87398,0 -115.696266,-51.82228 -115.696266,-115.69626 V 125.49273 c 0,-63.873979 51.822286,-115.69626 115.696266,-115.69626 h 366.3715 c 31.93699,0 57.84813,25.911142 57.84813,57.84813 v 347.08879 c 0,25.18804 -16.14927,46.64005 -38.56542,54.59417 v 80.3848 c 21.3315,0 38.56542,17.23392 38.56542,38.56542 0,21.3315 -17.23392,38.56542 -38.56542,38.56542 z M 165.73832,472.58152 c -21.33149,0 -38.56542,17.23393 -38.56542,38.56542 0,21.3315 17.23393,38.56542 38.56542,38.56542 h 308.52337 v -77.13084 z"
			}), /* @__PURE__ */ _jsx("g", {
				style: { fill: "none" },
				transform: "matrix(3.6563614,0,0,3.6563614,144.49465,65.097985)",
				children: /* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#ahci-clip)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							fillRule: "evenodd",
							clipRule: "evenodd",
							fill: "var(--bs-body-bg)",
							d: "M 95.6877,67.9677 C 92.2446,73.9488 72.2522,88.0617 48,88.0617 23.7478,88.0617 3.75535,73.9488 0.312312,67.9677 0.0605215,67.5303 -0.0207525,67.031 -0.0207525,66.5263 l 10e-8,-10.6476 c 0,-0.4414 0.0681357,-0.8801 0.2314514,-1.2902 C 1.69959,50.8499 5.59895,45.4192 10.6313,43.9621 11.2985,42.2494 12.2867,39.7456 13.2087,37.8974 13.0543,36.4833 13,35.0248 13,33.5512 c 0,-5.3238 1.1285,-9.9936 4.5288,-13.4711 1.5882,-1.6242 3.5588,-2.8701 5.8958,-3.8066 5.5971,-4.5471 13.5674,-8.37238 24.489,-8.37238 10.9216,0 19.0647,3.82528 24.6618,8.37238 2.337,0.9365 4.3076,2.1824 5.8958,3.8066 C 81.8715,23.5576 83,28.2274 83,33.5512 c 0,1.4736 -0.0543,2.9321 -0.2087,4.3462 0.922,1.8482 1.9102,4.352 2.5774,6.0647 5.0323,1.4571 8.9317,6.8878 10.4206,10.6264 0.1633,0.4101 0.2315,0.8488 0.2315,1.2902 v 10.6476 c 0,0.5047 -0.0813,1.004 -0.3331,1.4414 z M 51.253,32.2606 C 51.0828,30.9345 51.0018,29.747 50.9995,28.686 v -0.0839 c 0.0053,-3.0779 0.6781,-5.0806 1.7529,-6.3107 1.3648,-1.5619 4.1855,-2.7586 10.1305,-2.1152 6.023,0.6518 9.3896,2.1467 11.2983,4.0987 1.8479,1.8899 2.8187,4.7173 2.8187,9.2763 0,4.8439 -0.6981,7.7056 -2.2329,9.4465 C 73.3075,44.6531 70.4335,46 64.1386,46 59.2994,46 56.5326,44.4261 54.7637,42.2493 52.8644,39.912 51.7955,36.4878 51.253,32.2606 Z m -6.506,0 c 0.1702,-1.3262 0.2512,-2.5136 0.2535,-3.5746 v -0.0839 c -0.0053,-3.0779 -0.6781,-5.0807 -1.7529,-6.3107 -1.3648,-1.5619 -4.1855,-2.7586 -10.1305,-2.1152 -6.023,0.6518 -9.3896,2.1467 -11.2983,4.0987 -1.8479,1.8898 -2.8187,4.7173 -2.8187,9.2763 0,4.8439 0.6981,7.7056 2.2329,9.4465 C 22.6925,44.6531 25.5665,46 31.8614,46 c 4.8392,0 7.606,-1.5739 9.3749,-3.7507 1.8993,-2.3374 2.9682,-5.7615 3.5107,-9.9887 z m 3.9419,11.7377 c -0.2297,0.0012 0.2296,0 0,0 -0.2295,0 -1.1481,0.0012 -1.3778,0 -0.4234,0.7092 -0.8943,1.3899 -1.4185,2.0349 C 42.8139,49.8219 38.2182,52 31.8613,52 24.9615,52 19.9049,50.564 16.7324,46.9657 16.552,46.7611 16.3906,46.5469 16.3906,46.5469 L 16,46.9657 v 26.3366 c 5.7392,3.119 18.0576,8.7161 32,8.7161 13.9424,0 26.2608,-5.5971 32,-8.7161 V 46.9657 l -0.3906,-0.4188 c 0,0 -0.1322,0.1811 -0.3418,0.4188 C 76.0951,50.564 71.0385,52 64.1387,52 57.7818,52 53.1861,49.8219 50.1074,46.0332 49.5832,45.3882 49.1123,44.7075 48.6889,43.9983 Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fillRule: "evenodd",
							clipRule: "evenodd",
							fill: "var(--bs-body-bg)",
							d: "m 58,57 c 2.2091,0 4,1.7909 4,4 v 8 c 0,2.2092 -1.7909,4 -4,4 -2.2091,0 -4,-1.7908 -4,-4 v -8 c 0,-2.2091 1.7909,-4 4,-4 z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fillRule: "evenodd",
							clipRule: "evenodd",
							fill: "var(--bs-body-bg)",
							d: "m 38,57 c 2.2091,0 4,1.7909 4,4 v 8 c 0,2.2092 -1.7909,4 -4,4 -2.2091,0 -4,-1.7908 -4,-4 v -8 c 0,-2.2091 1.7909,-4 4,-4 z"
						})
					]
				})
			})]
		})
	]
});
export default SvgGitbibleHeaderIcon;
